<!-- OTPVerification.vue -->
<template>
	<div class="min-h-screen bg-gray-50 flex">
		<!-- Left Panel - Brand Banner -->
		<div class="hidden lg:flex relative flex-1">
			<div class="flex-1 bg-gradient-to-br from-primary to-blue-800">
				<!-- Geometric Pattern Background -->
				<div class="absolute inset-0 opacity-10">
					<svg
						class="absolute inset-0 h-full w-full"
						xmlns="http://www.w3.org/2000/svg"
					>
						<defs>
							<pattern
								id="geometric-pattern"
								x="0"
								y="0"
								width="40"
								height="40"
								patternUnits="userSpaceOnUse"
							>
								<circle
									cx="20"
									cy="20"
									r="2"
									fill="currentColor"
								/>
								<path
									d="M20 0 L40 20 L20 40 L0 20 Z"
									fill="none"
									stroke="currentColor"
									stroke-width="1"
								/>
							</pattern>
						</defs>
						<rect
							width="100%"
							height="100%"
							fill="url(#geometric-pattern)"
						/>
					</svg>
				</div>

				<!-- Logo Area -->
				<div class="absolute top-8 left-8 z-10">
					<div class="flex items-center">
						<!-- Logo Placeholder - Replace with your actual logo -->
						<div
							class="w-12 h-12 bg-white bg-opacity-20 rounded-xl flex items-center justify-center backdrop-blur-sm"
						>
							<img
								src="/assets/Logo/nexus.svg"
								alt="Company Logo"
								class="w-8 h-8 object-contain"
								onerror="
									this.style.display = 'none';
									this.nextElementSibling.style.display =
										'block';
								"
							/>
							<!-- Fallback icon if logo fails to load -->
							<svg
								style="display: none"
								class="w-7 h-7 text-white"
								fill="currentColor"
								viewBox="0 0 20 20"
							>
								<path d="M10 2L3 7v11h4v-6h6v6h4V7l-7-5z" />
							</svg>
						</div>
						<span class="ml-3 text-2xl font-bold text-white"
							>ClientPortal</span
						>
					</div>
				</div>

				<!-- Content -->
				<div
					class="relative flex flex-col justify-center h-full px-12 text-white"
				>
					<div class="max-w-md mx-auto">
						<h3 class="text-4xl font-bold leading-tight mb-6">
							Security First
						</h3>
						<p class="text-xl leading-relaxed opacity-90 mb-8">
							We've sent a verification code to ensure your
							account security and complete the registration
							process.
						</p>

						<!-- Security Points -->
						<div class="space-y-4">
							<div class="flex items-center">
								<div
									class="flex-shrink-0 w-6 h-6 bg-white bg-opacity-20 rounded-full flex items-center justify-center mr-3"
								>
									<svg
										class="w-3 h-3"
										fill="currentColor"
										viewBox="0 0 20 20"
									>
										<path
											fill-rule="evenodd"
											d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
											clip-rule="evenodd"
										/>
									</svg>
								</div>
								<span class="text-lg opacity-90"
									>Secure Verification</span
								>
							</div>
							<div class="flex items-center">
								<div
									class="flex-shrink-0 w-6 h-6 bg-white bg-opacity-20 rounded-full flex items-center justify-center mr-3"
								>
									<svg
										class="w-3 h-3"
										fill="currentColor"
										viewBox="0 0 20 20"
									>
										<path
											fill-rule="evenodd"
											d="M18 8a6 6 0 01-7.743 5.743L10 14l-1 1-1 1H6v2H2v-4l4.257-4.257A6 6 0 1118 8zm-6-4a1 1 0 100 2 2 2 0 012 2 1 1 0 102 0 4 4 0 00-4-4z"
											clip-rule="evenodd"
										/>
									</svg>
								</div>
								<span class="text-lg opacity-90"
									>Account Protection</span
								>
							</div>
							<div class="flex items-center">
								<div
									class="flex-shrink-0 w-6 h-6 bg-white bg-opacity-20 rounded-full flex items-center justify-center mr-3"
								>
									<svg
										class="w-3 h-3"
										fill="currentColor"
										viewBox="0 0 20 20"
									>
										<path
											fill-rule="evenodd"
											d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
											clip-rule="evenodd"
										/>
									</svg>
								</div>
								<span class="text-lg opacity-90"
									>Fast & Reliable</span
								>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Right Panel - OTP Form Section -->
		<div
			class="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:px-12 xl:px-16 bg-white"
		>
			<div class="mx-auto w-full max-w-md">
				<!-- Logo for Mobile/Small Screens -->
				<div class="lg:hidden mb-8 text-center">
					<div class="flex justify-center items-center mb-4">
						<!-- Logo Placeholder for mobile -->
						<div
							class="w-12 h-12 bg-primary bg-opacity-10 rounded-xl flex items-center justify-center mr-3"
						>
							<img
								src="/path/to/your/logo.png"
								alt="Company Logo"
								class="w-8 h-8 object-contain"
								onerror="
									this.style.display = 'none';
									this.nextElementSibling.style.display =
										'block';
								"
							/>
							<svg
								style="display: none"
								class="w-7 h-7 text-primary"
								fill="currentColor"
								viewBox="0 0 20 20"
							>
								<path d="M10 2L3 7v11h4v-6h6v6h4V7l-7-5z" />
							</svg>
						</div>
						<span class="text-2xl font-bold text-gray-900"
							>InsurePortal</span
						>
					</div>
				</div>

				<!-- Header -->
				<div class="space-y-8">
					<div>
						<h2 class="text-3xl font-bold text-gray-900 mb-3">
							Verify Your Email
						</h2>
						<p class="text-gray-600 text-base leading-relaxed">
							We sent a 4-digit code to
							<strong class="text-gray-900">{{ email }}</strong
							>. Enter it below to verify your account.
						</p>
					</div>

					<!-- OTP Form -->
					<form @submit.prevent="handleOTPSubmit" class="space-y-8">
						<!-- OTP Input Fields -->
						<div class="flex justify-center space-x-4">
							<input
								v-for="(digit, index) in otp"
								:key="index"
								ref="otpInputs"
								v-model="otp[index]"
								type="text"
								maxlength="1"
								class="w-14 h-14 text-center text-xl font-semibold text-gray-900 bg-white border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-primary focus:border-primary focus:ring-2 focus:ring-opacity-20 transition-all duration-200"
								@input="handleInput(index, $event)"
								@keydown="handleKeydown(index, $event)"
								required
							/>
						</div>

						<!-- Error Message -->
						<div v-if="error" class="rounded-lg bg-red-50 p-4">
							<div class="text-sm text-red-700 text-center">
								{{ error }}
							</div>
						</div>

						<!-- Submit Button -->
						<button
							type="submit"
							:disabled="loading"
							class="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-primary hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
						>
							<span v-if="loading" class="flex items-center">
								<svg
									class="animate-spin -ml-1 mr-3 h-4 w-4 text-white"
									xmlns="http://www.w3.org/2000/svg"
									fill="none"
									viewBox="0 0 24 24"
								>
									<circle
										class="opacity-25"
										cx="12"
										cy="12"
										r="10"
										stroke="currentColor"
										stroke-width="4"
									></circle>
									<path
										class="opacity-75"
										fill="currentColor"
										d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
									></path>
								</svg>
								Verifying...
							</span>
							<span v-else>Verify Code</span>
						</button>
					</form>

					<!-- Resend Code -->
					<div class="text-center">
						<span class="text-gray-600 text-sm"
							>Didn't receive a code?</span
						>
						<button
							@click="resendCode"
							:disabled="resendLoading"
							class="ml-1 text-primary hover:text-blue-700 font-medium text-sm transition-colors duration-200 disabled:opacity-50"
						>
							{{ resendLoading ? 'Sending...' : 'Resend Code' }}
						</button>
					</div>
				</div>
			</div>
		</div>

		<!-- Mobile Header (Brand Banner Collapsed) -->
		<div
			class="lg:hidden fixed top-0 left-0 right-0 bg-primary text-white px-4 py-3 z-10"
		>
			<div class="flex items-center justify-between">
				<div class="flex items-center">
					<div
						class="w-8 h-8 bg-white bg-opacity-20 rounded-md flex items-center justify-center mr-2"
					>
						<img
							src="/path/to/your/logo.png"
							alt="Company Logo"
							class="w-5 h-5 object-contain"
							onerror="
								this.style.display = 'none';
								this.nextElementSibling.style.display = 'block';
							"
						/>
						<svg
							style="display: none"
							class="w-4 h-4"
							fill="currentColor"
							viewBox="0 0 20 20"
						>
							<path d="M10 2L3 7v11h4v-6h6v6h4V7l-7-5z" />
						</svg>
					</div>
					<span class="font-semibold">InsurePortal</span>
				</div>
				<span class="text-sm opacity-90">Security First</span>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { ValidatePassword, VerifyClientOtp } from '../api/auth';

export default {
	name: 'OTPVerification',
	data() {
		return {
			otp: ['', '', '', ''],
			email: this.$route.params.email || '',
			error: '',
			loading: false,
			resendLoading: false,
		};
	},
	computed: {
		...mapGetters('auth', [
			'selectRegId',
			'isPasswordReset',
			'forgotPasswordRef',
		]),
	},
	methods: {
		...mapActions('auth', ['setAuthData', 'setRegId']),
		handleInput(index, event) {
			const value = event.target.value;
			if (value.length === 1 && index < 3) {
				this.$refs.otpInputs[index + 1].focus();
			}
		},
		handleKeydown(index, event) {
			if (event.key === 'Backspace' && !this.otp[index] && index > 0) {
				this.$refs.otpInputs[index - 1].focus();
			}
		},
		otpData() {
			const code = this.otp.join('');
			return {
				registrationId: this.selectRegId,
				registrationCode: code,
			};
		},
		async handleOTPSubmit() {
			this.error = '';
			this.loading = true;

			try {
				const code = this.otp.join('');
				if (code.length !== 4 || !/^\d{4}$/.test(code)) {
					this.error = 'Please enter a valid 4-digit code';
					this.loading = false;
					return;
				}

				await new Promise((resolve) => setTimeout(resolve, 1000));
				if (!this.isPasswordReset) {
					const res = await VerifyClientOtp(this.otpData());
					if (res.status) {
						Event.$emit('notifications:show', {
							type: 'success',
							title: 'Otp Verified',
							message: `Create your password`,
							duration: 3000,
						});
						this.$router.push({
							name: 'Set_Password',
							params: { email: this.email },
						});
					}
				} else {
					const res = await ValidatePassword({
						forgotPasswordSystemRef: this.forgotPasswordRef,
						code: code,
					});
					if (res.status) {
						Event.$emit('notifications:show', {
							type: 'success',
							title: 'Otp Verified',
							message: `Reset your password`,
							duration: 3000,
						});
						this.$router.push({
							name: 'Set_Password',
							params: { email: this.email },
						});
					}
				}
			} catch (err) {
				console.log('error', err);
				let errorMessage =
					err.response.data.errors || 'An error occured';
				this.error = errorMessage;
				Event.$emit('notifications:show', {
					type: 'error',
					title: 'Verification error',
					message: `${errorMessage}. Please try again`,
					duration: 3000,
				});
			} finally {
				this.loading = false;
			}
		},
		async resendCode() {
			this.resendLoading = true;
			this.error = '';

			try {
				// Simulate resend API call
				await new Promise((resolve) => setTimeout(resolve, 1000));
				this.error = 'New code sent to your email';
			} catch (err) {
				this.error = 'Failed to resend code. Please try again.';
			} finally {
				this.resendLoading = false;
			}
		},
	},
	mounted() {
		console.log('regId', this.selectRegId);
	},
};
</script>

<style scoped>
/* Mobile padding adjustment for fixed header */
@media (max-width: 1024px) {
	.flex-col {
		padding-top: 4rem;
	}
}

/* Enhanced focus effects for OTP inputs */
input:focus {
	box-shadow: 0 0 0 2px rgba(17, 159, 225, 0.2);
	transform: scale(1.05);
}

/* OTP Input styling */
input[type='text'] {
	transition: all 0.2s ease-in-out;
}

input[type='text']:hover {
	border-color: #119fe1;
}

/* Button hover animations */
button {
	transition: all 0.2s ease-in-out;
}

button:hover:not(:disabled) {
	transform: translateY(-1px);
}

button:active:not(:disabled) {
	transform: translateY(0);
}

/* Logo fade-in animation */
.flex.items-center {
	animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
	from {
		opacity: 0;
		transform: translateY(-10px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

/* Mobile optimizations */
@media (max-width: 640px) {
	.space-x-4 > * + * {
		margin-left: 0.75rem;
	}

	input[type='text'] {
		width: 3rem;
		height: 3rem;
		font-size: 1rem;
	}
}
</style>
